export const LAYOUT_ERRORS = {
  missingLayoutInstance: 'MissingLayoutInstanceError',
  missingPageDefinition: 'MissingPageDefinitionError',
  pageRenderer: 'PageRendererError',
  viewRenderer: 'ViewRendererError',
} as const;
